exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".paged-quotes__controls{margin-top:2em;margin-bottom:2em}.paged-quotes__item{margin-bottom:4em}.paged-quotes__nav-btn{cursor:pointer;font-size:.9em;font-family:FranklinGothicDemi}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d1a2b82","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/paged-quotes/paged-quotes.vue
// module id = 66
// module chunks = 0